export interface TicketSale {
  id: string
  transaction_id: string
  target: string
  target_email: string
  target_identifier: string
  age_group_id: number
  product_id: string
  product_name: string
  zone_from_id: string
  zone_from_name: string
  zone_to_id: string
  zone_to_name: string
  validity_starts: Date
  validity_ends: Date
  group_size: number
  authority: string
  ticket_data: string
  created: Date
  updated: Date
}

export enum TicketSaleTabType {
  DETAILS = 'details',
  QR_CODE = 'qr_code'
}

export interface FetchTicketSaleListParams {
  page: number
  ordering: string
}

export interface TicketProduct {
  id: string
  name: string
}

export interface BulkSaleTicketProductInfo {
  title: string
  body: string
}

export interface BulkSaleTicketProduct {
  id: string
  name: string
  description: string
  ageGroupId: number
  info: BulkSaleTicketProductInfo
}

export interface FetchTicketSaleTargetListParams {
  page: number
  ordering: string
}

export interface FetchAllTicketSaleTargetListParams {
  disable_pagination: boolean
}

export interface TicketSaleTarget {
  id: string
  identifier: string
  description: string
  authority: string
  created: Date
  updated: Date
}

export enum TicketSaleTargetTabType {
  DETAILS = 'details'
}

interface AgeGroup {
  id: number
  name: string
}

interface Zone {
  id: number
  name: string
}

export interface SalesChannel {
  external_id: string
}

export interface SalesChannelInfo {
  zones: Zone[]
  age_groups: AgeGroup[]
}

export interface BulkTicketSale {
  id: string
  created: Date
  updated: Date
  target: string
  external_product_id: string
  external_age_group_id: number
  external_zone_from_id: number
  external_zone_from_name: string
  external_zone_to_id: number
  external_zone_to_name: string
  valid_from: Date
  valid_to: Date
  event_identification: string
  total_requested_quantity: number
  total_processed_count: number
  total_cancelled_count: number
  has_processing_batches: boolean
  has_failed_batches: boolean
}

export enum BatchStatus {
  QUEUED = 'queued',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  PARTIALLY_PROCESSED = 'partially_processed',
  CANCELLING = 'cancelling',
  CANCELLED = 'cancelled',
  PARTIALLY_CANCELLED = 'partially_cancelled',
  FAILED = 'failed'
}

export interface BulkTicketSaleBatch {
  id: string
  created: Date
  updated: Date
  requested_quantity: number
  has_csv_file: boolean
  status: BatchStatus
}

export interface BulkTicketSaleBatchProgress {
  status: BatchStatus
  requested_quantity: number
  travel_account_count: number
  processed_count: number
  cancelled_count: number
  estimated_seconds: number
}

export enum BulkTicketSaleTabType {
  DETAILS = 'details',
  DOWNLOAD = 'download'
}

export interface BulkTicketSaleBatchDownloadUrl {
  download_url: string
}
